import { FC, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeContext } from '../global/ThemeContext';
import useTranslations from '../global/translation/hooks/translation';

// Added dark mode toggle functionality
const DarkModeToggle: FC = () => {
  const { darkMode, toggleDarkMode } = useThemeContext();
  const { currentLanguage } = useTranslations();

  useEffect(() => {
    document.body.style.transition = 'background-color 0.5s ease';
    document.body.style.backgroundColor = darkMode ? '#121212' : '#ffffff';
  }, [darkMode]);

  return (
    <Tooltip title={darkMode ? (currentLanguage === 'en' ? 'Light mode' : 'Tryb jasny') : currentLanguage === 'en' ? 'Dark mode' : 'Tryb ciemny'}>
      <IconButton
        onClick={toggleDarkMode}
        sx={{
          color: darkMode ? '#FFF' : '#000',
          transition: 'transform 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(30deg)',
          },
        }}
      >
        {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
